<template>
  <router-view ref="workspace"></router-view>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {},
  provide: function () {
    return {
      request: {
        table: 'getClbStepTemplateTable',
        detail: 'getClbStepTemplateDetail',
        create: 'createClbStepTemplateData',
        update: 'updateClbStepTemplateData',
      },
      scope: 'clb',
      create: this.create,
      update: this.update,
      visibleGuide: false,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    create (form) {
      request.common('createClbStepTemplateData', form).then(({data}) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.workspace.onReload()
        }, () => {
          this.$router.push({path: '/clb-step-template/update/' + data.id})
        })
      })
    },
    update (id, form) {
      request.common('updateClbStepTemplateData', {id, ...form}).then(({data}) => {
        this.$alert(this.$route.meta.title + '成功!', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/clb-step-template/update/' + id})
        })
      })
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/clb-step-template/pages/ClbStepTemplateForm.vue